export default __webpack_public_path__ + "static/media/mastercard_image.be766e9f.svg";